module.exports = __webpack_public_path__ + "img/download-appstore.e16e9c48.svg";